import { createContext, useReducer, useContext } from "react";
import { weatherDataReducer } from "../reducers/weatherDataReducer";

const WeatherDataContext = createContext(null);

const WeatherDataDispatchContext = createContext(null);

export function WeatherDataProvider({ children }) {
  const [weatherData, dispatch] = useReducer(weatherDataReducer, {});

  return (
    <WeatherDataContext.Provider value={weatherData}>
      <WeatherDataDispatchContext.Provider value={dispatch}>
        {children}
      </WeatherDataDispatchContext.Provider>
    </WeatherDataContext.Provider>
  );
}

export function useWeatherData() {
  return useContext(WeatherDataContext);
}

export function useWeatherDataDispatch() {
  return useContext(WeatherDataDispatchContext);
}
